type ModuleGuidance = {
  label: string;
  replacement?: string;
  replacementPath?: string;
};

const moduleGuidance: Record<string, ModuleGuidance> = {
  Department: { label: 'підрозділи персоналу', replacement: 'HR персоналу ресторану', replacementPath: '/management/employees' },
  EmployeeDossiers: { label: 'кадрові досьє', replacement: 'HR персоналу ресторану', replacementPath: '/management/employees' },
  EvaluationQuestion: { label: 'кадрові оцінки', replacement: 'HR персоналу ресторану', replacementPath: '/management/employees' },
  HallsPayroll: { label: 'зарплата залів', replacement: 'зарплата ресторану', replacementPath: '/management/restaurant-payroll' },
  KitchenEmployees: { label: 'спільний HR', replacement: 'HR персоналу ресторану', replacementPath: '/management/employees' },
  MonthlyRevenue: { label: 'загальна виручка', replacement: 'зарплата ресторану', replacementPath: '/management/restaurant-payroll' },
  Salary: { label: 'загальна зарплата', replacement: 'зарплата ресторану', replacementPath: '/management/restaurant-payroll' },
  SalaryPayroll: { label: 'загальна зарплата', replacement: 'зарплата ресторану', replacementPath: '/management/restaurant-payroll' },
};

const systemModules = new Set(['AiAssistant', 'Export', 'GoogleDocumentAiSettings', 'OperatingGroups', 'Permissions', 'Roles', 'Seed', 'Users']);

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const getOperatingContextErrorToast = (
  error: unknown,
): { title: string; message: string } | null => {
  if (!isRecord(error)) return null;
  const response = isRecord(error.response) ? error.response : null;
  const data = response && isRecord(response.data) ? response.data : null;
  if (!response || !data) return null;

  const status = response.status;
  const code = typeof data.code === 'string' ? data.code : '';
  const controller = typeof data.controller === 'string' ? data.controller : '';
  const message = typeof data.message === 'string' ? data.message : '';

  if (status === 403 && code === 'restaurant-scope-unsupported') {
    const guidance = moduleGuidance[controller];
    const moduleName = guidance?.label ?? 'ця операція';
    const replacement = guidance?.replacement && guidance.replacementPath
      ? ` Заміна: ${guidance.replacement} (${guidance.replacementPath}).`
      : ' Підтримуваної заміни для цієї дії поки немає.';
    return {
      title: 'Операція недоступна в ресторані',
      message: `Модуль «${moduleName}» не підтримує контекст окремої операційної групи. Зміна ролі не усуне це обмеження.${replacement}`,
    };
  }

  if (status === 403 && code === 'all-groups-read-only') {
    return {
      title: 'Огляд усіх груп — лише читання',
      message: systemModules.has(controller)
        ? 'Системні зміни не виконуються в режимі огляду всіх груп. Зміна ролі не усуне це обмеження.'
        : 'Щоб змінити дані ресторану, оберіть конкретну операційну групу. Огляд усіх груп залишається лише для читання.',
    };
  }

  if (status === 409 && controller === 'KitchenEmployees' &&
      message.startsWith('Особисте табелювання перенесено')) {
    return {
      title: 'Особисте табелювання доступне в ресторані',
      message: 'Використовуйте ресторанний графік і табель (/schedule).',
    };
  }

  if (status === 409 && controller === 'KitchenEmployees' &&
      message.startsWith('Історичний HR закрито після переходу')) {
    return {
      title: 'Спільний HR недоступний після переходу',
      message: 'Для персоналу відкрийте HR ресторану (/management/employees).',
    };
  }

  return null;
};
